import LegalPage from "@/components/feature/LegalPage";
import { privacySections } from "@/mocks/legalData";

export default function PrivacyPolicyPage() {
  return (
    <LegalPage
      breadcrumb="Privacy Policy"
      badge="Legal"
      title="Privacy Policy"
      updated="August 20, 2026"
      sections={privacySections}
    />
  );
}